<template>
  <!-- 我的消息 -->
    <div class="form-content">
        <!-- title -->
        <div class="home-header">
          <!-- title -->
          <headers :params="hraderP"></headers>
          <div class="mines">
            <div @click="nimeColor = true" :class="{'color1':nimeColor,'color2':!nimeColor}" class="notice">未读消息</div>
            <div @click="nimeColor = false" :class="{'color1':!nimeColor,'color2':nimeColor}" class="notice">已读消息</div>
          </div>
        </div>
        <!-- <div class="h24"></div> -->
        <div style="height:80px;background: #EFEFF4;" v-if="!isNativeApp"></div>
        <div style="height: 3.2rem;background: #EFEFF4;" v-if="isNativeApp"></div>
        <div v-if="nimeColor">
          <unreadNotice></unreadNotice>
        </div>
        <div v-if="!nimeColor">
          <readNotice></readNotice>
        </div>
        <!-- 联系客服 -->
        <a href=""></a>
    </div>
</template>

<script>
import headers from '@/components/headerslf'
import unreadNotice from '@/view/notice/unreadNotice'
import readNotice from '@/view/notice/readNotice'
export default {
  name: 'add-demand-form',
  components: { headers ,unreadNotice,readNotice},
  data () {
    return {
      hraderP: {
        title: '我的消息',
        lefticon: true
      },
      nimeColor:true,
      isNativeApp:false
    }
  },
  created(){
    this.isNativeApp = !(($HMD$.rNavigator && ($HMD$.rNavigator.toLowerCase() === 'ios' || $HMD$.rNavigator.toLowerCase() === 'android')))
  },
  mounted() {
    
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
.form-content{
  background: #FFF;
  .h24{
    height: 120px;
    background: #EFEFF4;
  }
  .mines{
    width: 100%;
    background: #ffffff;
    display: flex;
    justify-content:space-between;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    box-sizing: border-box;
    .notice{
      width: 48%;
      height:44px;
      line-height: 44px;
      font-weight: bold;
      background: #fff;
    }
    .color1{
      color: #2177FF;
      border-bottom:2px solid  #2F7BFF;

    }
    .color2{
      color: #6D6D6D;
      border-bottom:2px solid  #fff;
    }
  }
}
.home-header{
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9;
}
</style>



// WEBPACK FOOTER //
// src/view/notice/noticelist.vue